export default __webpack_public_path__ + "static/media/Inter-UI-Light-BETA.2ff1fba4.woff";